export const linkResolver = (doc) => {
  const pathLang = doc._meta.lang.split('-')[0]
  const pathUID = doc._meta.uid

  return `/${pathLang}/${pathUID}`
}
